import { useGetDealGeneralPartnerViewV3 } from "@vega-api/generated/deal/deal";
import { useDefaultCurrency } from "@vega-core/utils/formatMoney";

export const useDealCurrency = (dealId?: string) => {
  const defaultCurrency = useDefaultCurrency();
  const { data: currency, isLoading } = useGetDealGeneralPartnerViewV3(
    dealId ?? "",
    {
      query: {
        enabled: !!dealId,
        select: (data) => data.data?.deal.currency,
      },
    },
  );

  return {
    currency: currency || defaultCurrency,
    isLoading,
  };
};
